import Component from './Component'

export default class Label extends Component {

	static _type = 'Label'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	constructor (params) {
        super(params)

		// Default parameters
        this.params = Object.assign({
            format: value => value,
        }, this.params)
    }

	tether () {
		super.tether()

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil

		// Own DOM elements
		this.label_el = this.base.querySelector(`#${this.form.name}_${this.params.name}`)
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Register event handlers
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event

		if ('init' in this.params && typeof this.params.init == 'function') {
			this.params.init(this)
		}
	}

	updateListener = (value, errors) => {

		// If the value changed, update it on the input as well
		$(this.label_el).html(this.params.format(value))

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			if (('prepend' in this.params || 'append' in this.params)) {
				$(this.base).find('.input-group').removeClass('is-invalid')
			}
			$(this.input_el).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			if (('prepend' in this.params || 'append' in this.params)) {
				$(this.base).find('.input-group').addClass('is-invalid')
			}
			$(this.input_el).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		delete this.label_el
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
